module.exports = __webpack_public_path__ + "img/u172.59a3a3d2.svg";